var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#00A0F3",
    stroke: "#00A0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0166 8.63041L13.3371 10.978L8.09877 10.978C7.93613 10.978 7.80625 11.1111 7.80625 11.2728L7.80625 11.7272C7.80625 11.8889 7.93613 12.022 8.09877 12.022L13.3371 12.022L11.0166 14.3696C10.9029 14.4846 10.9029 14.6706 11.0166 14.7856L11.0166 14.7857L11.3342 15.107C11.4486 15.2227 11.6344 15.2227 11.7488 15.107L11.7488 15.107L15.1085 11.708C15.2222 11.593 15.2222 11.407 15.1085 11.292L15.1085 11.292L11.7487 7.89301C11.7487 7.89301 11.7487 7.89301 11.7487 7.89301C11.6344 7.77733 11.4486 7.77733 11.3342 7.89301C11.3342 7.89301 11.3342 7.89301 11.3342 7.89301L11.0166 8.21436C10.9029 8.32938 10.9029 8.51538 11.0166 8.63041L11.0166 8.63041Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.22d58b42.svg";
export { ForwardRef as ReactComponent };